import { FC, HTMLAttributes, ReactNode } from "react"
import styled from "@emotion/styled"

export type PageProps = HTMLAttributes<HTMLDivElement>

export const Page = styled.div`
  background: ${({ theme }) => String(theme.colours.white)};
`
